module.exports = __webpack_public_path__ + "img/special_moisturejel.544e84e9.jpg";